import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Field, reduxForm, submit } from 'redux-form'
import Dialog, { DialogTitle, DialogContent, DialogActions } from 'material-ui/Dialog'
import MenuItem from 'material-ui/Menu/MenuItem'
import Divider from 'material-ui/Divider'
import Button from 'material-ui/Button'
import _ from 'lodash'
import { Translate } from 'react-redux-i18n'

import Loading from 'components/loading'
import { toggleInvoiceDialog } from 'modules/deposits'
import { addInvoice, reset as resetInvoices } from 'modules/invoices'
import { getCountries } from 'modules/invoices/countries'
import Group from './group'
import parametersSelector from 'selectors/parameters'
import currentUserSelector from 'selectors/current_user'
import errorsSelector from 'selectors/errors'
import jsonSelector from 'selectors/json'

const priority_countries = ['US', 'GB']

const InvoiceModalWrapper = ({ pdf_url }) =>
  pdf_url ? <InvoiceSuccessModalConnected /> : <InvoiceModalConnected />

const InvoiceModal = ({ toggleInvoiceDialog, open, loading, submit }) => (
  <React.Fragment>
    <Loading active={loading} />
    <Dialog open={open} onClose={toggleInvoiceDialog} id="invoice-modal" fullWidth>
      <DialogTitle>Generate invoice</DialogTitle>
      <DialogContent>
        <InvoiceModalReduxForm />
      </DialogContent>
      <DialogActions>
        <Button color="primary" onClick={() => submit('invoice_modal')}>
          Generate invoice
        </Button>
        <Button color="default" onClick={toggleInvoiceDialog}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  </React.Fragment>
)

const InvoiceSuccessModal = ({ toggleInvoiceDialog, resetInvoices, open, pdf_url }) => (
  <Dialog
    open={open}
    onClose={toggleInvoiceDialog}
    onExited={resetInvoices}
    id="invoice-success-modal"
  >
    <DialogTitle>Generate invoice</DialogTitle>
    <DialogContent>
      <p>
        The invoice has been sent to your email address.
        <br />
        Please download and pay it.
      </p>
    </DialogContent>
    <DialogActions>
      <Button color="primary" href={pdf_url || '#'} target="_blank" id="invoice-pdf-url">
        DOWNLOAD NOW
      </Button>
      <Button onClick={toggleInvoiceDialog}>Close</Button>
    </DialogActions>
  </Dialog>
)

const InvoiceModalForm = ({
  handleSubmit,
  toggleInvoiceDialog,
  config_parameters,
  countries,
  errors
}) => (
  <form
    className="form-horizontal backtesting_form"
    id="generate-invoice-form"
    onSubmit={handleSubmit}
  >
    {!_.isEmpty(errors) && (
      <div className="validate-error form-group">
        <div className="col-xs-offset-3 col-xs-9">
          <ul>
            {_.map(errors, (arr, attribute) =>
              _.map(arr, (msg, index) => (
                <li key={`${attribute}${index}`}>
                  <Translate value={attribute} /> {msg}
                </li>
              ))
            )}
          </ul>
        </div>
      </div>
    )}
    <Field component={Group} errors={errors} type="text" name="full_name" label="Name" />

    <Field component={Group} errors={errors} type="text" name="email" label="Email" disabled />

    <Field component={Group} errors={errors} type="text" name="phone" label="Phone" />

    <Field select component={Group} errors={errors} type="select" name="country" label="Country">
      {_.map(_.pick(countries, priority_countries), (country, code) => (
        <MenuItem key={code} value={code}>
          {country}
        </MenuItem>
      ))}
      <Divider light />
      {_.map(_.omit(countries, priority_countries), (country, code) => (
        <MenuItem key={code} value={code}>
          {country}
        </MenuItem>
      ))}
    </Field>

    <Field component={Group} errors={errors} type="text" name="state" label="State" />

    <Field component={Group} errors={errors} type="text" name="city" label="City" />

    <Field component={Group} errors={errors} type="text" name="address" label="Address" />

    <Field component={Group} errors={errors} type="text" name="postal_code" label="Postal Code" />

    <Field
      component={Group}
      errors={errors}
      type="text"
      name="amount"
      label="Amount, USD"
      helperText={
        config_parameters['invoiced.min_amount_for_transfer'] > 0 &&
        `Minimum amount for wire transfer is ${
          config_parameters['invoiced.min_amount_for_transfer']
        }`
      }
    />
  </form>
)

class InvoiceModalFormContainer extends Component {
  componentDidMount() {
    const { getCountries } = this.props
    getCountries()
  }
  render() {
    return <InvoiceModalForm {...this.props} />
  }
}

const mapStateToProps = state => ({
  open: state.deposits.index.invoice_dialog_opened,
  loading: state.invoices.index.loading || state.invoices.countries.loading,
  config_parameters: parametersSelector(state),
  initialValues: {
    full_name: currentUserSelector(state).name,
    email: currentUserSelector(state).email,
    phone: currentUserSelector(state).phone
  },
  countries: jsonSelector('invoices.countries')(state),
  errors: errorsSelector('invoices.index', 'validation_error')(state),
  pdf_url: jsonSelector('invoices.index')(state).pdf_url
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    { toggleInvoiceDialog, addInvoice, resetInvoices, getCountries, submit },
    dispatch
  )

const InvoiceModalReduxForm = connect(mapStateToProps, mapDispatchToProps)(
  reduxForm({
    form: 'invoice_modal',
    onSubmit: (props, dispatch, { addInvoice }) => addInvoice(props),
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true
  })(InvoiceModalFormContainer)
)

const InvoiceModalConnected = connect(mapStateToProps, mapDispatchToProps)(InvoiceModal)
const InvoiceSuccessModalConnected = connect(mapStateToProps, mapDispatchToProps)(
  InvoiceSuccessModal
)

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceModalWrapper)



// WEBPACK FOOTER //
// ./src/containers/pages/dashboard/invoice_modal.js